/*
  フォームに不備がある場合に直接購入するボタンを非表示にする
  hasBundle: true or false // 有料バンドルがあるかどうか
*/

let hasBundle = false;
// hasUploadが定義されていない場合は false にする
let hasUpload = false;

function checkHasUpload() {
  // アップロードフィールドが含まれている場合、hasUploadを true にする
  hasUpload = true;
  $('div.shopify-payment-button').addClass('hide'); // 動的チェックアウトをデフォルトで非表示(ブラウザバック用)
  console.log('this page has an upload field.')
}

window.addEventListener('load', function () {
  // ページ読み込み時にrequiredフィールドがある場合に購入ボタンを非表示  
  let invalids = $(document.querySelectorAll('form.product-single__form [required]:invalid, form.product-single__form textarea[required]:invalid, form.product-single__form select[required]:invalid'));
  if (invalids.length > 0) $('div.shopify-payment-button').addClass('hide');

  $('input,textarea,select').change(function() {
    invalids = $(document.querySelectorAll('form.product-single__form [required]:invalid, form.product-single__form textarea[required]:invalid, form.product-single__form select[required]:invalid'));
    // すべてのrequiredフィールドが正しく入力されている かつ 有料バンドルがない かつ アップロードフィールドを持たない ときにのみ、動的チェックアウトボタンを表示する
    if (invalids.length === 0 && !hasBundle && !hasUpload) {
      $('div.shopify-payment-button').removeClass('hide');
    } else {
      $('div.shopify-payment-button').addClass('hide');
    }
  });
});